import React from 'react';
import { Trans } from 'react-i18next';
import * as S from './LimitsSection.styles';
import { LimitsEmpty } from '@/components/Profile/Limits/LimitsEmpty';
import { LimitsList } from '@/components/Profile/Limits/LimitsList';
import { ROUTES } from '@/constants/routes';
import { CustomLink } from '@/components/CustomLink/CustomLink';

const hasLimits = true;

export const LimitsSection = () => {
  return (
    <>
      <S.Box>
        {hasLimits ? <LimitsList /> : <LimitsEmpty />}

        <S.MoreInfo>
          <Trans
            i18nKey="pages.cabinet.placements_more_link"
            components={{
              link1: <CustomLink target="_blank" href={ROUTES.rules} />,
            }}
          />
        </S.MoreInfo>
      </S.Box>
    </>
  );
};
